import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { useIsObjectRecordCreatorEnabled } from '../../objectBuilder/hooks/useIsObjectRecordCreatorEnabled';
import { useSelectedTypeDefObjectNamesForTranslation } from '../../crmObjects/hooks/useSelectedObjectTypeDef';
import { getDisabledTooltipTitle } from '../../objectBuilder/utils/getDisabledTooltipTitle';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useIsUngatedForIARedesign } from '../../auth/hooks/useIsUngatedForIARedesign';

// This only returns scopes for custom objects.
// See https://git.hubteam.com/HubSpot/crm-index-ui/pull/3943 for
// context, but this is to allow the object builder panel to handle permissions
// checks for new objects using this button. In the future, this should likely
// rely on object type permissions canUserCreate and the button + panel should
// be platform-ized for re-use throughout HubSpot.
import { jsx as _jsx } from "react/jsx-runtime";
export const getCreateAccessScopes = objectTypeId => {
  if (isPortalSpecificObjectType(objectTypeId)) {
    return ['custom-object-access', 'custom-object-write'];
  }
  return null;
};
const CreateObjectButton = ({
  hasAllScopes,
  onCreateObject,
  typeDef
}) => {
  const accessScopes = getCreateAccessScopes(typeDef.objectTypeId);
  const hasCreateAccess = !accessScopes || hasAllScopes(...accessScopes);
  const isObjectRecordCreatorEnabled = useIsObjectRecordCreatorEnabled();
  const translationOptions = useSelectedTypeDefObjectNamesForTranslation();
  const {
    singularForm,
    singularFormLowercase
  } = translationOptions;
  const isDisabled = !hasCreateAccess || !isObjectRecordCreatorEnabled;
  const isUngatedForIARedesign = useIsUngatedForIARedesign();
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !isDisabled,
    title: getDisabledTooltipTitle({
      isRecordCreatorEnabled: isObjectRecordCreatorEnabled,
      translationOptions
    }),
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium-test": "new-object-button",
      size: "small",
      marginInlineStart: isUngatedForIARedesign ? '200' : '300',
      disabled: isDisabled,
      onClick: onCreateObject,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "index.header.createObjectButton.label",
        options: {
          singularForm,
          singularFormLowercase
        }
      })
    })
  });
};
export default CreateObjectButton;